// extracted by mini-css-extract-plugin
export default {"displayText":"bWkf7Kw3k2","title":"pA5d8pdgmS","interiorName":"lJBpdDgt12","interiorList":"mXQKavWful","interiorDisclaimer":"sPAS93Tpsm"};